export { default } from "ember-stereo/helpers/sound-end-timestamp";
